module.exports = __webpack_public_path__ + "img/incorrect.77723e9d.svg";